/* Radiant Orange Practice Window Master JS */
document.addEventListener('DOMContentLoaded', function() {
  // Gallery Thumbnail Switcher
  const mainHeroImg = document.getElementById('ro-pw-main-hero-img');
  const thumbs = document.querySelectorAll('.ro-pw-gallery-thumb');
  
  if (mainHeroImg && thumbs.length > 0) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function() {
        const fullSrc = this.getAttribute('data-full-img');
        if (fullSrc) {
          mainHeroImg.style.opacity = '0.4';
          setTimeout(() => {
            mainHeroImg.src = fullSrc;
            mainHeroImg.style.opacity = '1';
          }, 150);
          thumbs.forEach(t => t.classList.remove('active'));
          this.classList.add('active');
        }
      });
    });
  }

  // FAQ Accordion Toggle
  const faqItems = document.querySelectorAll('.ro-pw-faq-item, .accordion-card');
  faqItems.forEach(item => {
    const question = item.querySelector('.ro-pw-faq-question, .accordion-trigger');
    if (question) {
      question.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        faqItems.forEach(otherItem => otherItem.classList.remove('open'));
        if (!isOpen) {
          item.classList.add('open');
        }
      });
    }
  });

  // Smooth Anchor Scrolling
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId && targetId !== '#') {
        const targetElem = document.querySelector(targetId);
        if (targetElem) {
          e.preventDefault();
          targetElem.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });
});
